import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { getMediaList } from "../../services/logout";
import "./media.css"
import { format, parseISO } from 'date-fns';

const Media = () => {
  const location = useLocation();
  const [mediaList, setMediaList] = useState([]);
  const [reasonFilter, setReasonFilter] = useState('');
  const [mediaTypeFilter, setMediaTypeFilter] = useState('');

  // Dynamically determine the page title
  const getTitle = () => {
    if (location.pathname === "/mediums-media") return "Media Library: Mediums";
    if (location.pathname === "/clients-media") return "Media Library: Clients";
    if (location.pathname === "/general-public") return "Media Library: General Public";
    return "Media Library";
  };
   const routeToTypeMap = {
    "/mediums-media": "mediums",
    "/clients-media": "clients",
    "/general-public": "general-public",
  };
  useEffect(() => {
    let type = routeToTypeMap[location.pathname] || "mediums";
    const filters = {
      reason: reasonFilter,
      mediaType: mediaTypeFilter,
    };
  console.log(filters);
    getMediaList(type,filters)
      .then((data) => {

        if (data.data.status) {
          console.log(data.data.data)
          setMediaList(data.data.data);
        }
      })
      .catch(() => { });
  }, [reasonFilter, mediaTypeFilter, location.pathname]);

  return (
    <>
      {/* Top Header */}
      <div className="login-registerheader">
        <div className="container">
          <div className="logo-top">
            {" "}
            <img src="images/logo-verysoul.png" alt="logo" />
          </div>
          <div className="right-login-register">
            <p>

              {/* <Link to={"/login"}>Login</Link> */}
            </p>
          </div>
        </div>
      </div>
      {/* Filters */}
      <div className="container mt-4">
        <h3 className="fw-bold text-media">{getTitle()}</h3>
        <div className="row mt-3">
          <div className="col-md-6 mb-3">
            <label htmlFor="reasonFilter" className="form-label">
              Filter By Reason for Recommendation :
            </label>
            <select
              className={`selectmenu-element form-item__element--select has-placeholder url-input-info url-input-info-select custom-select-modern`}
              name="content_type"
              id="content_type"
              value={reasonFilter}
              onChange={(e) => setReasonFilter(e.target.value)}
             
            >
              <option disabled value="">
                Select...
              </option>
              <option value="About VerySoul">About VerySoul</option>
              <option value="Mentions VerySoul">
                Mentions VerySoul
              </option>
              <option value="Aligns with VerySoul Mission">Aligns with VerySoul Mission</option>
              <option value="Other Reason">Other Reason</option>
            </select>
          </div>
          <div className="col-md-6 mb-3">
            <label htmlFor="mediaTypeFilter" className="form-label">
              Filter By Media Type :
            </label>
            <select
              className={`selectmenu-element form-item__element--select has-placeholder url-input-info url-input-info-select custom-select-modern`}
              name="content_type"
              id="content_type"
               value={mediaTypeFilter}
              onChange={(e) => setMediaTypeFilter(e.target.value)}
            >
              <option disabled value="">
                Select...
              </option>
              <option value="Blog Post">Blog Post</option>
              <option value="Social Media Post (Instagram, LinkedIn, X)">
                Social Media Post (Instagram, LinkedIn, X)
              </option>
              <option value="YouTube">YouTube</option>
              <option value="Podcast">Podcast</option>
              <option value="Email Newsletter">Email Newsletter</option>
              <option value="Infographic">Infographic</option>
              <option value="Reel / Short / TikTok">Reel / Short / TikTok</option>
              <option value="Webinar">Webinar</option>
              <option value="Case Study">Case Study</option>
              <option value="E-book / Guide">E-book / Guide</option>
              <option value="Testimonial (Text or Video)">
                Testimonial (Text or Video)
              </option>
              <option value="Live Stream (Instagram, Facebook, LinkedIn)">
                Live Stream (Instagram, Facebook, LinkedIn)
              </option>
              <option value="Quiz / Poll">Quiz / Poll</option>
              <option value="Whitepaper">Whitepaper</option>
              <option value="Explainer Video">Explainer Video</option>
              <option value="Product Demo">Product Demo</option>
              <option value="Slide Deck / Presentation">
                Slide Deck / Presentation
              </option>
              <option value="Press Release">Press Release</option>
              <option value="Interactive Tool (calculator, checklist)">
                Interactive Tool (calculator, checklist)
              </option>
              <option value="News Article / Editorial">
                News Article / Editorial
              </option>
            </select>

          </div>
        </div>
      </div>
      {/*  List */}
      {mediaList.map((item, index) => (
        <div key={index}>
          <div className="container mt-5">
            <h4 className="fw-bold text-dark">
              {item.title}
            </h4>
            <p className="mb-1">
              <span className="me-2 text-decoration-underline">{item.reason}</span> {" | "}
              <em><strong>{item.content_type}</strong></em>
            </p>

            <div className="row mt-3">
              {/* <div className="col-md-2">
                    <img
                      src="images/undraw_profile_1.svg"
                      alt="Podcast"
                      className="img-fluid rounded"
                    />
                  </div> */}
              <div className="col-md-10 d-flex align-items-center" style={{ minHeight: "100%" }}>
                <p className="mb-0 py-3 text-justify font-size-16">
                  {item.description}
                </p>
              </div>
            </div>

            <div className="d-flex flex-column align-items-start mt-3">
              <div className="text-muted mb-2">
                <img
                  src="images/clanderNew.png"
                  alt="Podcast"
                  className="img-fluid me-2"
                  style={{ width: "16px", height: "16px", marginTop: "-2px" }}
                />{" "}
                {format(parseISO(item.created_at), 'MMMM d, yyyy')}
                
              </div>
              <a
                  href={item.url}
                  className="btn btn-media d-flex justify-content-center align-items-center"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View
                </a>
            </div>
          </div>
          {index !== mediaList.length - 1 && <hr className="my-4 text-muted" />}
        </div>
      ))}
      <div className='footer-saction-home'>
        <div className="container">
          <div className='footer-logo-home'><img src="images/Union-icon.png" /> </div>
          <p>For greater perspective on life</p>
          <ul>
            <li>
              <Link target='_blank' to={'/terms-conditions'}>Terms & Conditions</Link>
              {/* <a href='#'>Terms& Conditions</a> */}
            </li>
            <li>|</li>
            <li>
              <Link target='_blank' to={'/privacy-policy'}>Privacy Policy</Link>
              {/* <a href='#'>Privacy Policy</a> */}
            </li>
          </ul>
          {/* <span><b>Note: For optimum performance: use Chrome, Safari, or Edge</b></span> */}
          <span>@2023 very Soul LLC. All right reserved.</span>
        </div>
      </div>
    </>
  );
};
export default Media;
